/**
 * Shared props for cascading objects through components
 *
 * @props
 * data: Object
 * selectedOptions: Array
 */
var ChildMixin = {
  props: {
    data: {
      type: Object,
      required: true,
    },
    selectedOptions: {
      type: Array,
      default: () => [],
    },
  },
};
export default ChildMixin;
